












































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { MasterModule } from '@/app/store/modules/master'

@Component({
  name: 'FilterChart',
  components: {
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) private isDisabled: boolean | undefined
  @Prop({}) private funcFilter: any | undefined
  @Prop({}) private funcClearFilter: any | undefined
  @Prop({}) private hasFilter: boolean | undefined
  @Prop({}) private onClearFilter: boolean | undefined

  @Watch('onClearFilter')
  public changeHasFilter(value: boolean, oldValue: boolean) {
    this.team = ''
    this.position = ''
    this.byPosition3 = []
    // this.positionId = ''
    this.dealercode = ''
    this.dealergroup = ''
    this.active = ''
    this.dealerarea = ''
    this.city = ''
    this.cityId = ''
    this.typeSales = ''
    this.dealername = ''
    this.dealerNameId = ''
    this.dealerBranch = ''
    this.dealerBranchId = ''
    this.filterDate = []
  }

  // enable button filter
  public get enableButtonFilter() {
    if (
      (this.teamOptions.length === 0 &&
        this.byPosition3.length === 0 &&
        this.dealercode.length === 0 &&
        this.dealergroup.length === 0 &&
        this.active.length === 0 &&
        this.typeSales.length === 0 &&
        this.dealerarea.length === 0 &&
        this.cityOptions.length === 0 &&
        this.dealername.length === 0 &&
        this.dealerBranch.length === 0 &&
        this.filterDate.length === 0) ||
      this.filterDate === []
    ) {
      return true
    } else {
      return false
    }
  }

  public dealercode: string = ''
  public dealergroup: string = ''

  // FIlter By Position
  public byPosition3: any = []
  public byPosition2: string = ''
  public byPosition: string = ''
  public position: string = ''
  public positionId: string = ''
  @Watch('byPosition3')
  public onPosition2Changed(value: string, oldValue: string) {
    this.byPosition = this.byPosition3.toString()
  }
  // @Watch('byPosition')
  // public onPositionChanged(value: string, oldValue: string) {
  //   if (this.byPosition.length >= 3) {
  //     MasterModule.paginationParam.search = this.byPosition
  //     MasterModule.getPosition()
  //   }
  // }
  public positions: any = []
  public get positionData() {
    this.positions = MasterModule.PositionData.data
    return MasterModule.PositionData
  }
  public onRemovePosition(data) {
    const index = this.byPosition3.indexOf(data)
    this.byPosition3.splice(index, 1)
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
  }

  public onOptionClickPosition(data) {
    this.byPosition3.push(data)
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
    // console.log('By position')
    // console.log(this.byPosition)
    this.byPosition2 = ''
  }

  // FIlter By City
  public city: string = ''
  public cityId: string = ''
  public byCitizen(text) {
    const find = this.cityOptions.find((e) => e.name === text)
    const index = this.cityOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getCity()
    }
    if (this.cityOptions.length > 0) {
      this.cityId = this.cityOptions.find((e) => e.name === text).id
    }
  }
  public cityOptions: any = []
  public get cityCode() {
    this.cityOptions = MasterModule.MasterData.data
    return MasterModule.MasterData
  }

  public dealergroupId: string = ''
  public byDealerGroup(text) {
    const find = this.dealerGroupOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.dealerGroupOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerGroup()
    }
    const a = text.split('/')[1]
    if (this.dealerGroupOptions.length > 0 && text.length >= 3) {
      this.dealergroupId =
        this.dealerGroupOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public dealerGroupOptions: any = []
  public get groupCode() {
    this.dealerGroupOptions = MasterModule.DealerGroupData.data
    return MasterModule.DealerGroupData
  }

  public dealercodeId: string = ''
  public byDealerCode(text) {
    const find = this.dealerCodeOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.dealerCodeOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerName()
    }
    const a = text.split('/')[1]
    if (this.dealerCodeOptions.length > 0 && text.length >= 3) {
      this.dealercodeId =
        this.dealerCodeOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public dealerCodeOptions: any = []
  public get dealerCode() {
    this.dealerCodeOptions = MasterModule.DealerNameData.data
    return MasterModule.DealerNameData
  }

  // Filter by DealerName
  public dealername: string = ''
  public dealerNameId: string = ''
  public byDealerName(text) {
    const find = this.dealerNameOptions.find(
      (e) => e.name === text.split('/')[0] || ''
    )
    const index = this.dealerNameOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerName()
    }
    const a = text.split('/')[1]
    if (this.dealerNameOptions.length > 0 && text.length >= 3) {
      this.dealerNameId =
        this.dealerNameOptions.find((e) => e.id === Number(a)).id || ''
    }
  }
  public dealerNameOptions: any = []
  public get nameCode() {
    this.dealerNameOptions = MasterModule.DealerNameData.data
    return MasterModule.DealerNameData
  }

  // FIlter By Dealer Branch
  public dealerBranch: string = ''
  public dealerBranchId: string = ''
  public byDealerBranch(text) {
    const find = this.dealerBranchOptions.find((e) => e.name === text)
    const index = this.dealerBranchOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerBranch()
    }
  }
  public dealerBranchOptions: any = []
  public get dealerBranchCode() {
    this.dealerBranchOptions = MasterModule.DealerBranchData.data
    return MasterModule.DealerBranchData
  }

  public typeSales: string = ''
  public items: any = [
    'Salesman',
    'Salesman Counter',
    'Branch Manager',
    'Sales Manager',
    'Supervisor',
  ]
  public typeOptions: any = [
    {
      value: '',
      text: 'Sales Category',
    },
    {
      value: 'dnet',
      text: 'DNET',
    },
    {
      value: 'sfd',
      text: 'SFID',
    },
  ]

  public team: string = ''
  public teamOptions: any = [
    {
      value: '',
      text: 'Team Category',
    },
    {
      value: 'PC',
      text: 'PC',
    },
    {
      value: 'LCV',
      text: 'LCV',
    },
  ]

  public active: string = ''
  public activeOptions: any = [
    {
      value: '',
      text: 'Employee Status',
    },
    {
      value: 'true',
      text: 'Active',
    },
    {
      value: 'false',
      text: 'Non Active',
    },
  ]

  public statusRegistration: string = ''
  public statusRegistrationOptions: any = [
    {
      value: '',
      text: 'Registration Status',
    },
    {
      value: true,
      text: 'Registered',
    },
    {
      value: false,
      text: 'Unregistered',
    },
  ]

  public dealerarea: string = ''
  public dealerAreaOptions: any = [
    {
      value: '',
      text: 'Dealer Area',
    },
    {
      value: 'KALIMANTAN & IBT',
      text: 'KALIMANTAN & IBT',
    },
    {
      value: 'JABODETABEK',
      text: 'JABODETABEK',
    },
    {
      value: 'WEST JAVA',
      text: 'WEST JAVA',
    },
    {
      value: 'CENTRAL JAVA',
      text: 'CENTRAL JAVA',
    },
    {
      value: 'EAST JAVA',
      text: 'EAST JAVA',
    },
    {
      value: 'SUMATERA',
      text: 'SUMATERA',
    },
  ]

  public filterDate: any = []
}
